import React from 'react';
import {
    BundleGridDiv,
    BundleImageDiv,
    BundleContainerDiv,
    ImageContainer,
} from './BundleCards.styled';
import smallarrow from 'src/assets/images/SmallDownArrow.svg';

const BundleLayout = ({
    isExpand,
    bundleClickHandler = () => {},
    isBundle,
    children,
    imageMargin,
}) => {
    return (
        <>
            <BundleGridDiv gridTemplateColumns={isBundle && '10% auto'}>
                {isBundle ? (
                   <BundleImageDiv style = {{marginRight:'2%'}}>
                        <ImageContainer
                            cursor={'pointer'}
                            src={smallarrow}
                            alt="down-arrow"
                            isExpanded={isExpand ? true : false}
                            onClick={bundleClickHandler}
                            margin={imageMargin}
                        />
                    </BundleImageDiv>
                ) : null}
                <BundleContainerDiv gridColumChildren={!isBundle && '1/-1'}>
                    {children}
                </BundleContainerDiv>
            </BundleGridDiv>
        </>
    );
};

export default BundleLayout;
